/* GroundingForce theme script. No dependencies. Everything here is progressive enhancement:
   without JavaScript the pages still read in full (tabs show every panel, sliders scroll by touch,
   accordions are native <details>). Hooks are data-gf-* attributes written by the sections. */
(function () {
  'use strict';

  function qs(sel, root) { return (root || document).querySelector(sel); }
  function qsa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function once(el, key) {
    var k = '__gf_' + key;
    if (el[k]) return false;
    el[k] = true;
    return true;
  }
  function on(mq, fn) {
    if (!mq) return;
    if (mq.addEventListener) mq.addEventListener('change', fn);
    else if (mq.addListener) mq.addListener(fn);
  }

  var reducedMotion = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  /* Videos marked data-gf-autoplay start muted and looping, unless the visitor asked their device for less motion.
     Without script (or with reduced motion) they keep their normal play controls. */
  function playVideo(v) {
    if (reducedMotion || !v.hasAttribute('data-gf-autoplay')) return;
    if (!v.hasAttribute('data-gf-keep-controls')) v.removeAttribute('controls');
    try { var p = v.play(); if (p && p.catch) p.catch(function () { v.setAttribute('controls', ''); }); } catch (err) {}
  }
  function initVideo(v) {
    if (!once(v, 'video') || reducedMotion) return;
    if (!('IntersectionObserver' in window)) return;
    var byScript = false;
    var userPaused = false;
    v.addEventListener('pause', function () {
      if (byScript) byScript = false;
      else if (!v.ended) userPaused = true;
    });
    v.addEventListener('play', function () { userPaused = false; });
    new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (v.closest('[hidden]')) return;
        if (en.isIntersecting) {
          if (!userPaused) playVideo(v);
        } else if (!v.paused) {
          byScript = true;
          try { v.pause(); } catch (err) { byScript = false; }
        }
      });
    }, { threshold: 0.25 }).observe(v);
  }

  /* ---------- Mobile menu ---------- */
  document.addEventListener('click', function (e) {
    var link = e.target.closest('.gf-mnav a');
    var closer = e.target.closest('[data-gf-close-menu]');
    var node = link || closer;
    if (node) {
      var det = node.closest('details');
      if (det) det.removeAttribute('open');
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') qsa('.gf-burger[open]').forEach(function (d) { d.removeAttribute('open'); });
  });

  /* ---------- Country selector auto submit ---------- */
  document.addEventListener('change', function (e) {
    var sel = e.target.closest('[data-gf-autosubmit]');
    if (sel && sel.form) sel.form.submit();
  });

  /* ---------- Lightbox (any image or link with data-gf-zoom) ---------- */
  var lb = null;
  var lbImg = null;
  function buildLightbox() {
    lb = document.createElement('dialog');
    lb.className = 'gf-lightbox';
    lb.setAttribute('aria-label', 'Enlarged image');
    lb.innerHTML = '<div class="gf-lb-inner"><img alt=""></div>' +
      '<button type="button" class="gf-lb-close" aria-label="Close"><svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg></button>';
    document.body.appendChild(lb);
    lbImg = lb.querySelector('img');
    lb.addEventListener('click', function (e) {
      if (e.target === lb || e.target.classList.contains('gf-lb-inner') || e.target.closest('.gf-lb-close')) closeLightbox();
    });
  }
  function closeLightbox() {
    if (!lb) return;
    if (typeof lb.close === 'function') lb.close(); else lb.removeAttribute('open');
  }
  function openLightbox(src, alt) {
    if (!src) return;
    if (!lb) buildLightbox();
    lbImg.src = src;
    lbImg.alt = alt || '';
    if (typeof lb.showModal === 'function') {
      if (!lb.open) lb.showModal();
    } else {
      lb.setAttribute('open', '');
    }
  }
  document.addEventListener('click', function (e) {
    var z = e.target.closest('[data-gf-zoom]');
    if (!z) return;
    var src = z.getAttribute('data-gf-zoom');
    if (!src) src = z.tagName === 'A' ? z.getAttribute('href') : (z.currentSrc || z.src);
    if (!src) return;
    e.preventDefault();
    openLightbox(src, z.getAttribute('alt') || z.getAttribute('data-gf-zoom-alt') || '');
  });

  /* ---------- Tabs (science on phones, how it works) ---------- */
  function initTabs(root) {
    if (!once(root, 'tabs')) return;
    var tabs = qsa('[role="tab"]', root);
    var panels = qsa('[role="tabpanel"]', root);
    if (!tabs.length || tabs.length !== panels.length) return;
    var mqText = root.getAttribute('data-gf-tabs-mq');
    var mq = mqText && window.matchMedia ? window.matchMedia(mqText) : null;
    var current = 0;
    tabs.forEach(function (t, i) { if (t.getAttribute('aria-selected') === 'true') current = i; });

    function media(panel, play) {
      qsa('video[data-gf-autoplay]', panel).forEach(function (v) {
        try {
          if (play) playVideo(v); else v.pause();
        } catch (err) {}
      });
    }
    function apply(focusTab) {
      var active = !mq || mq.matches;
      root.classList.toggle('is-active', active);
      panels.forEach(function (p, i) {
        var show = active ? i === current : true;
        p.hidden = !show;
        media(p, show);
      });
      tabs.forEach(function (t, i) {
        t.setAttribute('aria-selected', i === current ? 'true' : 'false');
        t.setAttribute('tabindex', i === current ? '0' : '-1');
      });
      if (focusTab) tabs[current].focus();
    }
    function select(i, focus) {
      current = (i + tabs.length) % tabs.length;
      apply(focus);
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { select(i, false); });
      t.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') { e.preventDefault(); select(i + 1, true); }
        else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') { e.preventDefault(); select(i - 1, true); }
        else if (e.key === 'Home') { e.preventDefault(); select(0, true); }
        else if (e.key === 'End') { e.preventDefault(); select(tabs.length - 1, true); }
      });
    });
    root.classList.add('is-ready');
    on(mq, function () { apply(false); });
    apply(false);
  }

  /* ---------- Sliders (photo reviews, life cards) ---------- */
  function initSlider(root) {
    if (!once(root, 'slider')) return;
    var track = qs('.gf-track', root);
    var prev = qs('[data-gf-prev]', root);
    var next = qs('[data-gf-next]', root);
    if (!track) return;
    var raf = 0;
    function stepSize() {
      var first = track.children[0];
      if (!first) return track.clientWidth;
      var cs = window.getComputedStyle(track);
      var gap = parseFloat(cs.columnGap || cs.gap) || 0;
      return first.getBoundingClientRect().width + gap;
    }
    function update() {
      var max = track.scrollWidth - track.clientWidth - 2;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max;
    }
    function go(dir) {
      var left = track.scrollLeft + dir * stepSize();
      if (typeof track.scrollTo === 'function') track.scrollTo({ left: left, behavior: 'smooth' });
      else track.scrollLeft = left;
    }
    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });
    track.addEventListener('scroll', function () {
      if (raf) window.cancelAnimationFrame(raf);
      raf = window.requestAnimationFrame(update);
    }, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  /* ---------- Comparison table toggle (phones) ---------- */
  function initCompare(root) {
    if (!once(root, 'cmp')) return;
    var buttons = qsa('[data-gf-cmp-set]', root);
    root.classList.add('is-ready');
    function set(v) {
      root.setAttribute('data-active', v);
      buttons.forEach(function (b) {
        b.setAttribute('aria-pressed', b.getAttribute('data-gf-cmp-set') === v ? 'true' : 'false');
      });
    }
    buttons.forEach(function (b) {
      b.addEventListener('click', function () { set(b.getAttribute('data-gf-cmp-set')); });
    });
    set(root.getAttribute('data-active') || 'a');
  }

  /* ---------- Product page ---------- */
  function initPDP(root) {
    if (!once(root, 'pdp')) return;
    var form = qs('form[data-gf-form]', root);
    if (!form) return;
    var dataEl = qs('script[data-gf-variants]', root);
    var variants = [];
    try { variants = JSON.parse(dataEl.textContent); } catch (err) { variants = []; }

    var idInput = qs('input[name="id"]', form);
    var atc = qs('[data-gf-atc]', root);
    var qtyInput = qs('[data-gf-qty]', root);
    var priceEl = qs('[data-gf-price]', root);
    var compareEl = qs('[data-gf-compare]', root);
    var saveEl = qs('[data-gf-save]', root);
    var barPrice = qs('[data-gf-bar-price]', root);
    var barSel = qs('[data-gf-bar-sel]', root);
    var addLabel = (atc && atc.getAttribute('data-gf-add-label')) || 'Add to Cart';
    var soldLabel = (atc && atc.getAttribute('data-gf-sold-label')) || 'Sold Out';
    var current = null;
    var lastMedia = null;

    function qty() {
      var q = qtyInput ? parseInt(qtyInput.value, 10) : 1;
      return isFinite(q) && q > 0 ? q : 1;
    }
    function selectedOptions() {
      var opts = [];
      qsa('input[data-gf-opt]:checked', root).forEach(function (i) {
        opts[parseInt(i.getAttribute('data-gf-opt'), 10)] = i.value;
      });
      return opts;
    }
    function findVariant() {
      /* Single variant products ("Default Title") render no option pickers, so there is nothing to match: use the only variant. */
      if (!qs('input[data-gf-opt]', root)) return variants[0] || null;
      var sel = selectedOptions();
      for (var i = 0; i < variants.length; i++) {
        var ok = true;
        for (var k = 0; k < variants[i].options.length; k++) {
          if (variants[i].options[k] !== sel[k]) { ok = false; break; }
        }
        if (ok) return variants[i];
      }
      return null;
    }
    function atcText(v) {
      if (!v) return 'Unavailable';
      if (!v.available) return soldLabel;
      var q = qty();
            return q > 1 ? addLabel + ' (' + q + ')' : addLabel;
    }
    function token(str) {
      return String(str || '').toLowerCase().split(/[^a-z0-9]+/)[0];
    }

    /* Gallery */
    var track = qs('[data-gf-gal-track]', root);
    var slides = qsa('[data-gf-slide]', root);
    var thumbs = qsa('[data-gf-thumb]', root);
    var thumbRow = qs('[data-gf-thumbs]', root);
    var countEl = qs('[data-gf-gal-count]', root);
    var galIdx = 0;
    var galRaf = 0;
    function markGallery() {
      thumbs.forEach(function (t, k) { t.setAttribute('aria-current', k === galIdx ? 'true' : 'false'); });
      if (countEl) countEl.textContent = (galIdx + 1) + ' / ' + slides.length;
      slides.forEach(function (s, k) {
        if (k !== galIdx) { var v = qs('video', s); if (v && !v.paused) { try { v.pause(); } catch (err) {} } }
      });
      var t = thumbs[galIdx];
      if (t && thumbRow) {
        var left = t.offsetLeft - (thumbRow.clientWidth - t.clientWidth) / 2;
        if (typeof thumbRow.scrollTo === 'function') thumbRow.scrollTo({ left: left, behavior: 'smooth' });
        else thumbRow.scrollLeft = left;
      }
    }
    function gotoSlide(i, instant) {
      if (!track || !slides.length) return;
      i = Math.max(0, Math.min(slides.length - 1, i));
      var left = i * track.clientWidth;
      if (typeof track.scrollTo === 'function') track.scrollTo({ left: left, behavior: instant ? 'auto' : 'smooth' });
      else track.scrollLeft = left;
      galIdx = i;
      markGallery();
    }
    if (track && slides.length) {
      track.addEventListener('scroll', function () {
        if (galRaf) window.cancelAnimationFrame(galRaf);
        galRaf = window.requestAnimationFrame(function () {
          var i = Math.round(track.scrollLeft / (track.clientWidth || 1));
          if (i !== galIdx) { galIdx = i; markGallery(); }
        });
      }, { passive: true });
      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); gotoSlide(galIdx + 1); }
        else if (e.key === 'ArrowLeft') { e.preventDefault(); gotoSlide(galIdx - 1); }
      });
      thumbs.forEach(function (t, k) { t.addEventListener('click', function () { gotoSlide(k); }); });
      var gp = qs('[data-gf-gal-prev]', root);
      var gn = qs('[data-gf-gal-next]', root);
      if (gp) gp.addEventListener('click', function () { gotoSlide(galIdx - 1); });
      if (gn) gn.addEventListener('click', function () { gotoSlide(galIdx + 1); });
      window.addEventListener('resize', function () { gotoSlide(galIdx, true); });
      markGallery();
    }
    function showMediaFor(v) {
      if (!v || !v.media || !slides.length) return;
      if (v.media === lastMedia) return;
      var firstRun = lastMedia === null;
      lastMedia = v.media;
      if (firstRun) return;
      for (var i = 0; i < slides.length; i++) {
        if (String(slides[i].getAttribute('data-media-id')) === String(v.media)) { gotoSlide(i); return; }
      }
    }

    /* Bundle upgrade card follows the chosen mat size */
    var upsell = qs('[data-gf-upsell]', root);
    var upsellData = [];
    if (upsell) {
      var upEl = qs('script[data-gf-upsell-json]', upsell);
      try { upsellData = JSON.parse(upEl.textContent); } catch (err) { upsellData = []; }
    }
    function updateUpsell() {
      if (!upsell || !upsellData.length) return;
      var sizeInput = qs('input[data-gf-role="size"]:checked', root);
      var key = sizeInput ? token(sizeInput.value) : '';
      var hit = null;
      for (var i = 0; i < upsellData.length; i++) { if (upsellData[i].key === key) { hit = upsellData[i]; break; } }
      if (!hit) hit = upsellData[0];
      var now = qs('[data-gf-up-now]', upsell);
      var was = qs('[data-gf-up-was]', upsell);
      var save = qs('[data-gf-up-save]', upsell);
      var link = qs('[data-gf-up-link]', upsell);
      if (now) now.textContent = hit.price;
      if (was) { if (hit.was) { was.textContent = hit.was; was.hidden = false; } else { was.hidden = true; } }
      if (save) { if (hit.save) { save.textContent = 'Save ' + hit.save; save.hidden = false; } else { save.hidden = true; } }
      if (link && hit.url) link.setAttribute('href', hit.url);
    }

    function update() {
      var v = findVariant();
      current = v;
      qsa('input[data-gf-opt]:checked', root).forEach(function (i) {
        var lbl = qs('[data-gf-optlabel="' + i.getAttribute('data-gf-opt') + '"]', root);
        if (lbl) lbl.textContent = i.getAttribute('data-label') || i.value;
      });
      if (v) {
        if (idInput) idInput.value = v.id;
        if (priceEl) priceEl.textContent = v.price;
        if (compareEl) {
          if (v.compare) { compareEl.textContent = v.compare; compareEl.hidden = false; }
          else { compareEl.hidden = true; }
        }
        if (saveEl) {
          if (v.save) { saveEl.textContent = 'Save ' + v.save + ' (' + v.pct + '%)'; saveEl.hidden = false; }
          else { saveEl.hidden = true; }
        }
        if (atc) { atc.disabled = !v.available; atc.textContent = atcText(v); }
        if (barPrice) barPrice.textContent = v.price;
        if (barSel) {
          var picked = [];
          qsa('input[data-gf-opt]:checked', root).forEach(function (i) { picked.push(i.getAttribute('data-label') || i.value); });
          barSel.textContent = picked.join(' \u00b7 ');
        }
        showMediaFor(v);
        try {
          if (window.history && window.history.replaceState) {
            var u = new URL(window.location.href);
            u.searchParams.set('variant', v.id);
            window.history.replaceState({}, '', u.toString());
          }
        } catch (err) {}
      } else if (atc) {
        atc.disabled = true;
        atc.textContent = 'Unavailable';
      }
      updateUpsell();
    }

    root.addEventListener('change', function (e) {
      if (e.target.closest('input[data-gf-opt]')) update();
    });

    /* Quantity */
    if (qtyInput) {
      var minus = qs('[data-gf-qty-minus]', root);
      var plus = qs('[data-gf-qty-plus]', root);
      var setQty = function (n) {
        n = Math.max(1, Math.min(99, n));
        qtyInput.value = n;
        if (atc && current) atc.textContent = atcText(current);
      };
      if (minus) minus.addEventListener('click', function () { setQty(qty() - 1); });
      if (plus) plus.addEventListener('click', function () { setQty(qty() + 1); });
      qtyInput.addEventListener('change', function () { setQty(qty()); });
    }

    update();

    /* Sticky buy bar: shows whenever the main Add to Cart button is off screen (above or below)
       after a small scroll, and steps aside when the footer is on screen. It is measured on scroll
       (not with an observer) so a quick jump to the top or bottom of the page never leaves it stuck. */
    var bar = qs('[data-gf-bar]', root);
    if (bar && atc) {
      var foot = qs('.gf-footer') || qs('footer');
      var barOn = false;
      var barTick = false;
      var barBtn = qs('[data-gf-bar-btn]', bar);
      var barLink = qs('[data-gf-bar-info]', bar);
      var measureBar = function () {
        barTick = false;
        var vh = window.innerHeight || document.documentElement.clientHeight || 0;
        var top = window.pageYOffset || document.documentElement.scrollTop || 0;
        var r = atc.getBoundingClientRect();
        var atcOnScreen = r.height > 0 && r.bottom > 0 && r.top < vh;
        var fr = foot ? foot.getBoundingClientRect() : null;
        var footOnScreen = !!fr && fr.height > 0 && fr.top < vh - 24;
        var show = r.height > 0 && r.bottom < 0 && !footOnScreen;
        if (show === barOn) return;
        barOn = show;
        bar.classList.toggle('gf-show', show);
        bar.setAttribute('aria-hidden', show ? 'false' : 'true');
        if (barBtn) barBtn.tabIndex = show ? 0 : -1;
        if (barLink) barLink.tabIndex = show ? 0 : -1;
      };
      var queueBar = function () {
        if (barTick) return;
        barTick = true;
        window.requestAnimationFrame(measureBar);
      };
      window.addEventListener('scroll', queueBar, { passive: true });
      window.addEventListener('resize', queueBar);
      window.addEventListener('pageshow', queueBar);
      window.addEventListener('load', queueBar);
      if (barBtn) barBtn.addEventListener('click', function () {
        if (form.requestSubmit) form.requestSubmit(); else form.submit();
      });
      measureBar();
    }

    /* Ajax add to cart: opens Dawn's cart drawer when it is on the page */
    form.addEventListener('submit', function (e) {
      if (!window.fetch || !window.FormData) return;
      e.preventDefault();
      if (atc && atc.disabled) return;
      if (atc) atc.classList.add('gf-loading');
      var fd = new FormData();
      fd.append('id', idInput ? idInput.value : '');
      fd.append('quantity', String(qty()));
      fd.append('sections', 'cart-drawer,cart-icon-bubble');
      fd.append('sections_url', window.location.pathname);
      var addUrl = (window.routes && window.routes.cart_add_url) ? window.routes.cart_add_url : '/cart/add';
      var cartUrl = (window.routes && window.routes.cart_url) ? window.routes.cart_url : '/cart';
      fetch(addUrl, {
        method: 'POST',
        headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
        body: fd
      })
        .then(function (r) { return r.json(); })
        .then(function (json) {
          if (json.status) throw json;
          var drawer = document.querySelector('cart-drawer');
          if (drawer && typeof drawer.renderContents === 'function' && json.sections) {
            drawer.renderContents(json);
            /* Dawn's own product form clears this flag after a first add. Without it the drawer would open in its empty state. */
            if (drawer.classList.contains('is-empty')) drawer.classList.remove('is-empty');
            try {
              if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
                publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: idInput ? idInput.value : '', cartData: json });
              }
            } catch (err) {}
          } else {
            window.location.href = cartUrl;
          }
        })
        .catch(function () { window.location.href = cartUrl; })
        .then(function () { if (atc) atc.classList.remove('gf-loading'); });
    });
  }

  /* Floating Shop Now button (science page): appears after a short scroll, steps aside while the footer is on screen.
     Without script it simply stays visible. Measured on scroll so a quick jump never leaves it stuck. */
  function initStickyCta(el) {
    if (!once(el, 'stickycta')) return;
    var foot = qs('.gf-footer') || qs('footer');
    var link = qs('a', el);
    var tick = false;
    var measure = function () {
      tick = false;
      if (!el.isConnected) {
        window.removeEventListener('scroll', queue);
        window.removeEventListener('resize', queue);
        window.removeEventListener('pageshow', queue);
        window.removeEventListener('load', queue);
        return;
      }
      var vh = window.innerHeight || document.documentElement.clientHeight || 0;
      var top = window.pageYOffset || document.documentElement.scrollTop || 0;
      var fr = foot ? foot.getBoundingClientRect() : null;
      var footOnScreen = !!fr && fr.height > 0 && fr.top < vh - 24;
      /* Anything marked data-gf-sticky-stop (an in-page button, the fine print) also makes the floating button step aside */
      var stopOn = false;
      var stops = qsa('[data-gf-sticky-stop]');
      for (var i = 0; i < stops.length; i++) {
        var sr = stops[i].getBoundingClientRect();
        if (sr.height > 0 && sr.top < vh - 24 && sr.bottom > 24) { stopOn = true; break; }
      }
      var away = top <= 160 || footOnScreen || stopOn;
      el.classList.toggle('gf-away', away);
      el.setAttribute('aria-hidden', away ? 'true' : 'false');
      if (link) link.tabIndex = away ? -1 : 0;
    };
    var queue = function () {
      if (tick) return;
      tick = true;
      window.requestAnimationFrame(measure);
    };
    window.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue);
    window.addEventListener('pageshow', queue);
    window.addEventListener('load', queue);
    measure();
  }

  function boot(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    qsa('[data-gf-tabs]', root).forEach(initTabs);
    qsa('[data-gf-slider]', root).forEach(initSlider);
    qsa('[data-gf-cmp]', root).forEach(initCompare);
    qsa('[data-gf-pdp]', root).forEach(initPDP);
    qsa('video[data-gf-autoplay]', root).forEach(initVideo);
    qsa('[data-gf-sticky-cta]', root).forEach(initStickyCta);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(document); });
  else boot(document);
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
